import { Roles } from "../enums";

const hierachy: Record<Roles, Roles[]> = {
  [Roles.ADMIN]: [Roles.GERENT, Roles.SUPERVISOR, Roles.AGENT, Roles.AUDIT, Roles.SUPPORT, Roles.STORE, Roles.PARTNER],
  [Roles.GERENT]: [Roles.SUPERVISOR],
  [Roles.SUPERVISOR]: [Roles.AGENT, Roles.AUDIT, Roles.SUPPORT, Roles.GERENT],
  [Roles.AGENT]: [Roles.STORE, Roles.SUPERVISOR],
  [Roles.AUDIT]: [Roles.STORE, Roles.SUPERVISOR],
  [Roles.SUPPORT]: [Roles.STORE, Roles.SUPERVISOR],
  [Roles.STORE]: [Roles.PARTNER, Roles.AGENT, Roles.AUDIT, Roles.SUPPORT],
  [Roles.PARTNER]: [Roles.STORE]
}

export { hierachy }